import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

/** Reads the person's pages, scans news, runs the context pass and photo. */
export const runContactScanStep = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((i) => z.object({ contactId: z.string().uuid() }).parse(i))
  .handler(async ({ context, data }) => {
    const { runScanStep } = await import("@/lib/enrichment-steps.server");
    return runScanStep(context.userId, data.contactId);
  });

/** Stops a dropped request from leaving someone stuck as "still reading". */
export const markEnrichmentPartial = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((i) => z.object({ contactId: z.string().uuid() }).parse(i))
  .handler(async ({ context, data }) => {
    const { markPartial } = await import("@/lib/enrichment-steps.server");
    await markPartial(context.userId, data.contactId);
    return { ok: true };
  });
